import styled from 'styled-components'
import React from 'react'
import {useTemplate} from 'Event/TemplateProvider'
import {rgba} from 'lib/color'

export default function Container(props: {
  children: JSX.Element | JSX.Element[]
  disableSpacing: boolean
  postId: string
  textColor?: string
  defaultBackgroundColor?: string | null
  defaultBackgroundOpacity?: number | null
}) {
  const {
    disableSpacing,
    postId,
    textColor,
    defaultBackgroundColor,
    defaultBackgroundOpacity,
  } = props
  const {postStyles} = useTemplate()

  const marginBottom = disableSpacing ? 0 : postStyles.spacing
  const opacity = postStyles.backgroundOpacity ?? defaultBackgroundOpacity ?? 0
  const postBackgroundColor =
    postStyles.backgroundColor ?? defaultBackgroundColor
  const backgroundColor = postBackgroundColor
    ? rgba(postBackgroundColor, opacity / 100)
    : 'transparent'

  return (
    <Post
      aria-label="blog post"
      className="blog-post"
      id={`blog-post--${postId}`}
      marginBottom={marginBottom}
      textColor={textColor}
      backgroundColor={backgroundColor}
      backgroundOpacity={opacity}
    >
      {props.children}
    </Post>
  )
}

const Post = styled.div<{
  marginBottom: number
  textColor?: string
  backgroundColor: string
  backgroundOpacity: number
}>`
  margin-bottom: ${(props) => props.marginBottom}px;
  background-color: ${(props) => props.backgroundColor};
  ${(props) =>
    props.backgroundOpacity > 0
      ? `
    padding: ${props.theme.spacing[4]};
    border-radius: 4px;
  `
      : ''}

  img {
    max-width: 100%;
  }

  & > * {
    color: ${(props) => props.textColor};
  }
`
